import { render } from "./acquaint-logo.vue?vue&type=template&id=42b4e538"
const script = {}

import "./acquaint-logo.vue?vue&type=style&index=0&id=42b4e538&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__